import JSONUtils from '../../lib/JSONUtils';
import safeNotifyPopupOpener from '../../lib/safeNotifyPopupOpener';

export default function ZendeskAuthenticator() {
  let url = window.location.href;
  let protocol = window.location.protocol;
  let host = window.location.host;
  let responseParams = url.replace(`${protocol}//${host}/zendeskAuth#`, '');
  let queryJSON = JSONUtils.queryStringToJSON(responseParams);
  if (queryJSON) {
    safeNotifyPopupOpener(queryJSON, null);
    window.location.replace('about:blank');
    window.close();
  } else {
    safeNotifyPopupOpener(null, {
      code: 'Authentication error',
      description: 'Authentication error',
    });
    window.location.replace('about:blank');
    window.close();
  }
  return null;
}
